import { ENTERPRISE_PARTNER_ID, GROUP_STATUS, LEAD_TYPE } from '@brighte-enterprise/common/constants';

import { UserRole } from '@app-types/User';
import { EnterprisePartner } from '@typeDefs/groups';

export const enterpriseGroups: EnterprisePartner[] = [
  {
    id: ENTERPRISE_PARTNER_ID.ovoEnergy,
    name: 'OVO Energy',
    type: LEAD_TYPE.Concierge,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.active,
    },
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.evee,
    name: 'Evee',
    type: LEAD_TYPE.Concierge,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.active,
    },
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.commbank,
    name: 'CommBank',
    type: LEAD_TYPE.Marketplace,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.active,
    },
    configuration: {
      referralSupportsMultipleCategories: true,
      packageSupportsMultipleVendors: false,
      premiumLeads: true,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.act,
    name: 'ACT Government',
    type: LEAD_TYPE.Marketplace,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.active,
    },
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.tas,
    name: 'TAS Government',
    type: LEAD_TYPE.Marketplace,
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.rewiringAustralia,
    name: 'Rewiring Australia',
    type: LEAD_TYPE.Marketplace,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.active,
    },
    configuration: {
      referralSupportsMultipleCategories: true,
      packageSupportsMultipleVendors: true,
      premiumLeads: false,
      intake: true,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.oneMillionWomen,
    name: 'One Million Women',
    type: LEAD_TYPE.Concierge,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.inactive,
    },
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.racq,
    name: 'RACQ',
    type: LEAD_TYPE.Marketplace,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.inactive,
    },
    configuration: {
      referralSupportsMultipleCategories: true,
      packageSupportsMultipleVendors: false,
      premiumLeads: true,
      intake: false,
    },
  },
  {
    id: ENTERPRISE_PARTNER_ID.brighte,
    name: 'Brighte',
    type: LEAD_TYPE.Marketplace,
    status: {
      staging: GROUP_STATUS.active,
      uat: GROUP_STATUS.active,
      prod: GROUP_STATUS.inactive,
    },
    configuration: {
      referralSupportsMultipleCategories: false,
      packageSupportsMultipleVendors: false,
      premiumLeads: false,
      intake: false,
    },
  },
];

export enum FINANCIAL_PRODUCT_SLUG {
  Electrify2515 = 'electrify-2515',
}

export const states: Record<string, string> = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
};

export const showContactRoles = [UserRole.AdminOperations, UserRole.EnterpriseConcierge, UserRole.EnterprisePartnerPII];

export enum ALERT_LEVEL {
  Warning = 'warning',
  Critical = 'critical',
}

export const pipelineAlertThresholds: Record<ALERT_LEVEL, number> = {
  [ALERT_LEVEL.Critical]: 15,
  [ALERT_LEVEL.Warning]: 10,
};

export const newStatusStaleDays = 10;

export const allowedRolesForEnterprisePartners = [
  UserRole.Team,
  UserRole.Vendor,
  UserRole.Manager,
  UserRole.AdminOperations,
  UserRole.Admin,
  UserRole.SuperAdmin,
  UserRole.EnterpriseConcierge,
  UserRole.Service,
];

// Backward compatibility alias
export const allowedRolesForEnterpriseGroups = allowedRolesForEnterprisePartners;

export const allowedRolesForDocuments = [UserRole.SuperAdmin, UserRole.Admin, UserRole.AdminOperations];

export const VALID_FILE_EXTENSIONS = {
  IMAGES: ['jpg', 'jpeg', 'png'],
  DOCUMENTS: ['pdf'],
  SPREADSHEETS: ['csv'],
  ALL: ['jpg', 'jpeg', 'png', 'pdf', 'csv'],
};

export const internalRoles = [UserRole.SuperAdmin, UserRole.Admin, UserRole.AdminOperations];
